<template>
  <div class="application">
    <!-- 申请详情 -->
    <el-dialog
      title="申请贷款"
      @change="$forceUpdate()"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      width="70%"
    >
      <el-form
        :inline="true"
        :model="form"
        label-position="left"
        :rules="rules"
        ref="ruleForm"
      >
        <div class="LoanApplication">
          <!-- 服务网点 -->
          <!-- <div class="serviceOutlets">
            <el-form-item label="服务网点">
              <el-select @change="LookChange" value-key="departId" v-model="form.OrganizationItem" style="width: 322px">
                <el-option v-for="item in institutions" :key="item.departId" :label="item.departName"
                  :value="item"></el-option></el-select>
            </el-form-item>

          </div> -->

          <!-- 基础信息 -->
          <div class="BasicInformation">
            <div class="title">
              <p>基础信息</p>
            </div>

            <div class="textContent">
              <div class="Left">
                <el-form-item label="申请主体名称">
                  <el-input
                    v-model="form.ApplicationSubjectName"
                    :disabled="true"
                    placeholder=""
                  ></el-input>
                </el-form-item>
                <el-form-item label="法人姓名">
                  <el-input
                    v-model="form.LegalPersonName"
                    :disabled="true"
                    placeholder=""
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人姓名">
                  <el-input
                    v-model="form.agentName"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>

                <el-form-item label="法人身份证人面像">
                  <div class="textContent" style="width: 200px; height: 130px">
                    <el-image
                      :src="baseUrl + 'admin/file/get?ossFilePath=' + logoUrl2"
                    >
                      <div slot="error" class="image-slot">
                        <img src="../../assets/icon/imgError.png" />
                      </div>
                    </el-image>
                  </div>
                </el-form-item>
                <el-form-item label="营业执照">
                  <div class="textContent" style="width: 200px; height: 150px">
                    <el-image
                      :src="baseUrl + 'admin/file/get?ossFilePath=' + logoUrl"
                    >
                      <div slot="error" class="image-slot">
                        <img src="../../assets/icon/imgError.png" />
                      </div>
                    </el-image>
                  </div>
                </el-form-item>
              </div>

              <div class="Right">
                <el-form-item label="统一社会信用代码">
                  <el-input
                    v-model="form.SocialCreditId"
                    :disabled="true"
                    placeholder=""
                  ></el-input>
                </el-form-item>
                <el-form-item label="法人电话">
                  <el-input
                    v-model="form.legalPersonPhone"
                    :disabled="true"
                    placeholder=""
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人手机号">
                  <el-input
                    v-model="form.phone"
                    :disabled="true"
                    placeholder=""
                  ></el-input>
                </el-form-item>
                <el-form-item label="法人身份证国徽">
                  <div class="textContent" style="width: 200px; height: 130px">
                    <el-image
                      :src="baseUrl + 'admin/file/get?ossFilePath=' + logoUrl3"
                    >
                      <div slot="error" class="image-slot">
                        <img src="../../assets/icon/imgError.png" />
                      </div>
                    </el-image>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>

          <!-- 经营信息 -->

          <!-- 贷款信息 -->
          <div class="LoanInformation">
            <div class="title">
              <p>贷款申请信息</p>
            </div>
            <div class="textContent">
              <div class="LoanInformation_top">
                <div class="Left">
                  <el-form-item label="申请金额" prop="LoansAmount">
                    <el-input
                      :class="showMessage ? 'active' : ''"
                      @blur="clearMessage"
                      @focus="clearMessage"
                      v-model="form.LoansAmount"
                      type="number"
                      placeholder=""
                    ></el-input>
                    <div
                      v-show="showMessage"
                      style="
                        color: #f56c6c;
                        font-size: 12px;
                        line-height: 1;
                        padding-top: 4px;
                        position: absolute;
                        top: 100%;
                        left: 0;
                      "
                      class="item__error"
                    >
                      {{ promptMessage }}
                    </div>
                  </el-form-item>

                  <p>{{ bigNumber }}</p>
                  <span style="padding-top: 10px"> 元 </span>
                  <el-form-item
                    label="申请期限"
                    prop="loanTerm"
                    style="margin-left: 200px"
                  >
                    <el-input
                      v-model="form.loanTerm"
                      type="number"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                  <p>月</p>
                </div>
                <div class="Left">
                  <el-form-item label="经营年限" prop="YearManagement">
                    <el-input
                      v-model="form.YearManagement"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                  <p>年</p>
                  <el-form-item
                    label="年营业额"
                    prop="income"
                    style="margin-left: 200px"
                  >
                    <el-input
                      v-model="form.income"
                      placeholder=""
                      type="number"
                    ></el-input>
                  </el-form-item>
                  <p>元</p>
                </div>
                <div>
                  <el-form-item label="贷款资金用途" prop="fundUsage">
                    <el-select
                      v-model="form.fundUsage"
                      placeholder="请选择资金用途"
                      clearable
                      filterable
                      class="fund-usage-select"
                    >
                      <el-option
                        v-for="item in fundUsageOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <div
                  class="Left"
                  v-if="
                    form.fundUsage === '3' &&
                    identityObj?.identityTypeCode == '4'
                  "
                >
                  <el-form-item label="托管单号" prop="orderId">
                    <div
                      @click="handleCustodyOrderClick"
                      style="width: 100%; cursor: pointer"
                    >
                      <el-input
                        v-model="custodyOrderDisplay"
                        placeholder="请选择托管单号"
                        readonly
                        style="pointer-events: none"
                      >
                        <i slot="suffix" class="el-icon-arrow-down"></i>
                      </el-input>
                    </div>
                  </el-form-item>
                </div>
                <div
                  v-if="
                    form.fundUsage === '1' &&
                    identityObj?.identityTypeCode == '4'
                  "
                >
                  <div>
                    <el-form-item label="抵押仓单" label-width="94px">
                      <el-select
                        v-model="form.warehouseReceiptId"
                        placeholder="请选择待入库仓单"
                        @change="handleWarehouseReceiptChange"
                        style="width: 350px"
                      >
                        <el-option
                          v-for="item in warehouseReceiptOptions"
                          :key="item.id"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div
                    class="Left"
                    style="display: flex; align-items: flex-start"
                  >
                    <el-form-item
                      label="抵押数量(KG)"
                      label-width="110px"
                      prop="mortgageAmount"
                    >
                      <el-input
                        v-model="form.mortgageAmount"
                        placeholder="请输入抵押数量"
                        type="number"
                      ></el-input>
                    </el-form-item>
                    <div
                      style="
                        font-size: 12px;
                        color: #999;
                        margin-top: 5px;
                        margin-left: 10px;
                        flex: 1;
                      "
                    >
                      已选仓单可抵押数量为{{ balanceWeight }}KG。<br />
                      已抵押数量{{ pledgeWeight }}KG，出库中数量{{
                        dispatchingWeight
                      }}KG。
                    </div>
                  </div>
                </div>
              </div>
              <div class="LoanInformation_bottom">
                <span>用途说明</span>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入内容"
                  v-model="form.FundsUse"
                >
                </el-input>
              </div>
            </div>
          </div>

          <!-- 其他附件 -->
          <div class="OtherAccessories">
            <div class="title">
              <p>附件</p>
            </div>
            <div class="textContent">
              <!-- accept="|.doc,.docx,.xls,.xlsx,.pdf,.zip,.7z" -->
              <el-upload
                ref="pic1"
                multiple
                class="upload-demo"
                :limit="6"
                :action="uploadUrl"
                name="files"
                :auto-upload="false"
                :on-remove="handleRemove"
                :on-change="handleChangeUp"
                :file-list="fileList"
                :show-file-list="false"
              >
                <i class="el-icon-download"></i>
              </el-upload>

              <div class="Item" v-for="(item, index) in fileList" :key="index">
                <div class="del" @click="del(index)">X</div>
                <el-image
                  :src="'/api/admin/file/get?ossFilePath=' + item.imgUrl"
                  @click="AddFiles(item)"
                >
                  <div slot="error" class="image-slot">
                    <!-- <svg t="1702953208684" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3250" width="32" height="32"><path d="M293.7 635.7H643V592H293.7v43.7z m291.1-247.4H293.7V432h291.1v-43.7z m320.1-203.7v43.7l-43.6-43.6v1.2L816.4 141h1.1l-43.4-43.4 116.3-0.3h-684v87.3h-87.3v742.2h698.5v-87.3h87.3V184.6z m-654.8-43.7h508.3l-6.1 6.1 37.5 37.5H250.1v-43.6z m523.8 742.2H162.7V228.2h495l-4.6 4.6 120.8 120.8v529.5z m43.7-567.6L686.7 184.9l130.8-0.3v130.9z m43.7 480.3h-43.7V212.4l37.5 37.5 6.1-6.1v552z m-567.6-262H643v-43.7H293.7v43.7z m0 203.8H643v-43.7H293.7v43.7z" p-id="3251"></path></svg> -->
                    <i
                      class="el-icon-document-copy"
                      @click="AddFiles(item)"
                    ></i>
                  </div>
                </el-image>
                <span>
                  {{ item.FilesName }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-top: 20px" @click="back">取消</el-button>
        <!-- <el-button style="margin-top: 20px" @click="SaveBtn"
          >保存草稿</el-button
        > -->
        <el-button type="primary" @click="submitBtn"> 提交 </el-button>
      </div>
    </el-dialog>

    <!-- 托管单选择对话框 -->
    <DialogList
      v-model="showCustodyOrderDialog"
      title="选择托管单"
      :multiple="false"
      :columns="custodyOrderColumns"
      :api-function="getCustodyOrder"
      :api-params="custodyOrderApiParams"
      row-key="orderId"
      @confirm="handleCustodyOrderConfirm"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// 图片上传
import { uploadFile } from "@/api/fileApi";
//用户申请贷款
import {
  ApplicationLoan,
  AreaTree,
  selectDeptName,
  getWarehouseReceiptList,
  financeTypeList,
} from "@/api/RuralFinance";
import { digitUppercase } from "@/util/numConvert.js";
// 导入对话列表组件和托管单API
import DialogList from "@/components/DialogList/index.vue";
import { getApplyOrderList } from "../../api/projectManage";
//查询所在地区
export default {
  components: {
    DialogList,
  },
  data() {
    setTimeout(() => {
      // console.log(this.identityObj, "查看所有的东西");
      this.areaHasChild = this.identityObj.areaCode ? false : true;
      // this.form.areaCode = this.identityObj.areaCode;

      if (this.identityObj.areaCode && this.topSelectAreacode) {
        // 将两者转为字符串确保安全（如果原本不是字符串类型）
        const areaCode = Number(this.identityObj.areaCode);
        const topCode = String(this.topSelectAreacode);

        // 检查areaCode是否包含topSelectAreacode

        // if (areaCode.includes(topCode)) {
        this.form.areaCode = areaCode;
        this.form.areaName = this.identityObj.areaFullName
          ? this.identityObj.areaFullName.split("/").join("")
          : "";
        // }
      }

      this.form.areaName = this.identityObj.areaFullName
        ? this.identityObj.areaFullName.split("/").join("")
        : "";
    }, 100);
    //判断贷款的额度是否到达标准
    // var checkLoansAmount = (rule, value, callback) => {
    // // console.log(value,'查看拿到的值')
    //   if (!value) {
    //     return callback(new Error('请输入贷款金额'));
    //   }
    //   setTimeout(() => {
    //       if (value > this.maxMoney) {
    //         callback(new Error('超出贷款额度'));
    //       } else if(value < this.minMoney) {
    //         callback('低于贷款额度');
    //     }
    //     else {
    //     callback();
    //   }
    //   }, 1000);
    // };
    return {
      FinancialDetails: {},
      loanTypeId: "",
      balanceWeight: 0, //可抵押数量
      pledgeWeight: 0, //已抵押数量
      dispatchingWeight: 0, //出库中数量
      warehouseReceiptList: [],
      showApplyFor: false, //判断当前页面是农户还是公司
      fileList: [], //上传图片的列表,
      logoUrl: "", // 存储营业执照
      logoUrl2: "", // 存储人面像图片
      logoUrl3: "", // 存储国徽像图片
      dialogVisible: true,
      uploadUrl: `${window.globalUrl.HOME_API_WEI}/admin/file/upload`, //上传图片的地址
      baseUrl: window.globalUrl.HOME_API,
      form: {
        warehouseReceiptNumber: "", //仓库子单number编号
        mortgageAmount: "", //抵押数量
        warehouseReceiptId: "-1",
        areaCode: "",
        area: "",
        userType: "", //主体类型
        ApplicationSubjectName: "", //申请主体名称
        Address: "", //所在地址
        LegalPersonName: "", //法人姓名
        agentName: "", //授权代理人
        phone: "", //手机号
        SocialCreditId: "", //统一社会信用代码
        // identityId: "", //填写详细地址
        legalPersonNo: "", //法人身份证号
        agentNo: "", //代理人身份证号
        income: "", //年经营收入
        YearManagement: "", //实际经营收入
        BusinessContent: "", //经营内容,
        LoansAmount: "", //贷款金额
        FundsUse: "", //资金用途
        OrganizationItem: "",
        orderId: "", //托管单id
        loanTerm: "", //贷款期限
        fundUsage: "", //资金用途
        legalPersonPhone: "", //法人电话
      }, //这是输入基础信息
      fundUsageOptions: [], // 资金用途下拉选项
      options: [], // 所在地区
      financeProductId: "", //产品单号
      //主体类型
      types: [
        {
          label: "集体经济组织",
          value: "3",
        },
        {
          label: "农业企业",
          value: "41",
        },
        {
          label: "家庭农场",
          value: "42",
        },
        {
          label: "合作社",
          value: "43",
        },
      ],

      textarea2: "",
      regionOptions: [],
      props: {
        label: "areaName",
        children: "children",
        value: "id",
        fullPathName: "fullPathName",
        checkStrictly: true,
        emitPath: false,
      },
      maxMoney: "", //最大贷款额度
      minMoney: "", // 最小贷款额度
      institutions: [],
      rules: {
        // LoansAmount:[
        //   { validator:checkLoansAmount, trigger: 'change' },
        // ],
        LoansAmount: [
          { required: true, message: "请输入申请金额", trigger: "blur" },
        ],
        //申请期限
        loanTerm: [
          { required: true, message: "请输入申请期限", trigger: "blur" },
        ],
        income: [
          {
            required: true,
            message: "请输入年经营收入",
            trigger: "blur",
          },
        ],
        YearManagement: [
          {
            required: true,
            message: "实际经营年限",
            trigger: "blur",
          },
        ],
        // areaCode: [
        //   {
        //     required: true,
        //     message: "请选择地址",
        //     trigger: "change",
        //   },
        // ],
        fundUsage: [
          { required: true, message: "请选择资金用途", trigger: "change" },
        ],
        mortgageAmount: [
          { required: true, message: "请输入抵押数量", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              // 先尝试将值转换为数字
              const numValue = Number(value);
              // 判断是否为有效数字
              if (
                value === "" ||
                value === null ||
                value === undefined ||
                isNaN(numValue)
              ) {
                return callback(new Error("请输入有效的数字"));
              }
              // 验证是否大于0（考虑浮点数精度问题）
              if (numValue <= 0) {
                return callback(new Error("抵押数量不能为0或负数"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      isTrueMoney: "",
      showMessage: false, //是否显示提示
      promptMessage: "", //提示语
      is_host_plant: false, //是否托管
      is_host_warehouse: false, //是否仓单贷
      // 托管单选择相关
      showCustodyOrderDialog: false,
      custodyOrderDisplay: "", // 显示的托管单信息

      custodyOrderColumns: [
        { prop: "orderCode", label: "托管单号", width: 150 },
        { prop: "cropCode", label: "种养品种", width: 120 },
        { prop: "landArea", label: "托管面积(亩)", width: 120 },
        { prop: "univalentPrice", label: "托管价格", width: 150 },
        { prop: "createTime", label: "创建时间", width: 180 },
      ],
      custodyOrderApiParams: {
        // orderState: 1,
        // orderType: 1,
      }, // API额外参数
    };
  },
  computed: {
    ...mapGetters(["identityObj", "topSelectAreacode"]),
    bigNumber() {
      if (this.form && this.form.LoansAmount) {
        return digitUppercase(this.form.LoansAmount);
      } else {
        return "";
      }
    },
    // maxMoneyTip() {
    //   if (this.form.LoansAmount > this.maxMoney) {
    //     return "*超出贷款金额";
    //   } else if (this.form.LoansAmount < this.minMoney) {
    //     return "*低于贷款金额";
    //   } else {
    //     return "";
    //   }
    // },
    BigYearIncome() {
      if (this.form.income == 0) {
        return "";
      } else {
        return digitUppercase(this.form.income);
      }
    },
    warehouseReceiptOptions() {
      return [
        { id: "待入库仓单", label: "待入库仓单", value: "-1" },
        ...this.warehouseReceiptList.map((item) => ({
          id: item.id,
          label:
            item.number +
            item.grainCategoryLevel +
            item.grainCategoryName +
            " (可用 " +
            (item.balanceWeight || 0) +
            " KG)",
          value: item.id,
        })),
      ];
    },
  },
  mounted() {
    // console.log(this.form, "这里有值嘛");
    //回显
    this.FirstShow();
    this.getWarehouseReceiptList();
  },

  methods: {
    handleWarehouseReceiptChange(val) {
      if (val == "-1") {
        console.log('选择"待入库仓单"');
        // 选择的是"待入库仓单"，重置数量
        this.balanceWeight = 0;
        this.pledgeWeight = 0;
        this.dispatchingWeight = 0;
        this.form.warehouseReceiptNumber = "";
      } else {
        // 选择的是具体的仓单，根据ID查找并更新数量
        const selectedWarehouse = this.warehouseReceiptList.find(
          (item) => item.id === val
        );
        if (selectedWarehouse) {
          console.log(selectedWarehouse, "selectedWarehouse");
          this.balanceWeight = selectedWarehouse.balanceWeight || 0;
          this.pledgeWeight = selectedWarehouse.pledgeWeight || 0;
          this.dispatchingWeight = selectedWarehouse.dispatchingWeight || 0;
          this.form.warehouseReceiptNumber = selectedWarehouse.number || "";
        }
      }
    },

    async getWarehouseReceiptList() {
      let res = await getWarehouseReceiptList({});
      // console.log(res,'getWarehouseReceiptList');
      if (res.code == 0) {
        this.warehouseReceiptList = res.data;
      }
    },
    //回显
    FirstShow() {
      //手机号
      console.log(this.identityObj, "huhuhuh");
      this.form.phone = this.identityObj.contactPhone;
      this.form.agentName = this.identityObj.contactName;
      //申请主体名称
      this.form.ApplicationSubjectName = this.identityObj.identityName;
      //社会信用代码
      this.form.SocialCreditId = this.identityObj.identityCode;
      //法人姓名
      this.form.LegalPersonName = this.identityObj.bossName;
      //营业执照
      this.logoUrl = this.identityObj.businessLicense;
      console.log(this.logoUrl);
      //法人身份证人面像
      this.logoUrl2 = this.identityObj.userCardFrontImg;
      console.log(this.logoUrl2);
      //法人身份证国徽像
      this.logoUrl3 = this.identityObj.userCardBackImg;
      console.log(this.logoUrl3);
      //法人电话
      this.form.legalPersonPhone = this.identityObj.userName;
    },
    LookChange(val) {
      this.institutions.filter((item) => {
        if (item.departId == val.departId) {
          return (this.financeProductId = item.financeProductId);
        }
      });
    },
    //清除消息提示语
    clearMessage() {
      this.promptMessage = "";
      this.showMessage = false;
    },
    //文件上传
    async handleChangeUp(file, fileList) {
      console.log(fileList, "这是fileList");
      let param = new FormData();
      param.append("catalog", "financeAdd");
      param.append("file", file.raw);
      let res = await uploadFile(param);
      console.log(res, "这是res");
      // let imgUrl = "/api/admin/file/get?ossFilePath=" + res.data.url;
      let FilesName = res.data.sourceFileName;
      let imgUrl = res.data.url;

      let item = {
        FilesName: FilesName,
        imgUrl: imgUrl,
      };
      this.fileList.push(item);

      // this.files.push(fileList.name);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //附件上传图片的删除
    del(index) {
      let newFileList = this.fileList.filter((item, ind) => {
        if (index == ind) {
          let newFileList = this.fileList.splice(ind, 1);
          return newFileList;
        }
      });
    },
    //附件下载功能
    async AddFiles(item) {
      let dom = document.createElement("a");
      dom.style.display = "none";
      dom.href = "/api/admin/file/get?ossFilePath=" + item.imgUrl;
      dom.setAttribute("download", item.FilesName);
      document.body.appendChild(dom);
      dom.click();
    },
    //申请详情的弹窗
    handleClose(done) {
      this.$emit("closeDialog", false);
    },
    back() {
      this.$emit("closeDialog", false);
    },
    submit() {
      this.$emit("closeDialog", false);
    },
    // 查看金额
    maxMoneyTip() {
      // 检查输入框的值是否为空
      if (!this.form.LoansAmount.trim() || this.form.LoansAmount == "") {
        this.promptMessage = "请输入贷款金额";
        this.showMessage = true;
        return;
      }

      // 检查输入框的值是否大于最大额度
      if (this.maxMoney != 0) {
        if (parseInt(this.form.LoansAmount) > this.maxMoney) {
          this.promptMessage = "超出贷款额度";
          this.showMessage = true;
          return;
        }
      }
      // 检查输入框的值是否小于最小额度
      if (parseInt(this.form.LoansAmount) < this.minMoney) {
        this.promptMessage = "低于贷款额度";
        this.showMessage = true;
        return;
      }
    },
    // 获取资金用途选项
    async getFundUsageOptions() {
      console.log(this.loanTypeId, "hahahahah");
      try {
        // 根据apply-loan-h5.vue的使用方式，需要传递loanTypeId
        // 这里假设使用默认的贷款类型ID，您可能需要根据实际情况调整
        const params = {
          loanTypeId: this.loanTypeId, // 默认贷款类型ID，请根据实际情况调整
        };

        const res = await financeTypeList(params);
        console.log(res, "这是res");
        if (res.code === 0 && res.data) {
          // 将返回的数据映射为下拉选项格式
          this.fundUsageOptions = res.data.map((item) => ({
            label: item.fundUsageDesc,
            value: item.fundUsageParam,
          }));
        } else {
          console.error("获取资金用途列表失败:", res.message || "未知错误");
          this.fundUsageOptions = [];
        }
      } catch (error) {
        console.error("获取资金用途列表异常:", error);
        this.fundUsageOptions = [];
      }
    },

    //发布
    async submitBtn() {
      this.rules.income[0].required = true;
      this.rules.YearManagement[0].required = true;
      this.maxMoneyTip();
      this.$refs.ruleForm.validate(async (valid, obj) => {
        if (
          valid ||
          !this.form.LoansAmount.trim() ||
          !this.form.LoansAmount == ""
        ) {
          this.maxMoneyTip();
          if (this.showMessage) return;
          if (
            this.form.warehouseReceiptId != "-1" &&
            this.form.mortgageAmount > this.balanceWeight
          ) {
            this.$message.error("抵押数量不可大于余额");
            return;
          }
          let params = {
            financeProductId: this.financeProductId,
            departId: this.form.OrganizationItem.departId,
            name: this.form.ApplicationSubjectName,
            idCardNo: this.form.SocialCreditId,
            legalPersonNo: this.form.legalPersonNo,
            phone: this.form.phone,
            userCardFrontImg: this.logoUrl2,
            userCardBackImg: this.logoUrl3,
            files: JSON.stringify(this.fileList),
            income: this.form.income,
            operatYear: this.form.YearManagement,
            money: this.form.LoansAmount,
            use: this.form.FundsUse,
            status: 1,
            agentName: this.form.agentName,
            agentNo: this.form.agentNo,
            operatIntorducation: this.form.BusinessContent,
            licenseImg: this.logoUrl,
            orderId: this.form.orderId,
            warehouseNumber: this.form.mortgageAmount,
            warehouseId: this.form.warehouseReceiptId,
            warehouseCode: this.form.warehouseReceiptNumber,
            loanTerm: this.form.loanTerm,
            fundUsage: this.form.fundUsage, //资金用途
          };
          let res = await ApplicationLoan(params);
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$router.push(
              "/memberCenter/financalService/applicationRecord"
            );
            this.$emit("closeDialog", false);
          } else {
            this.$message.warning(res.msg);
          }
        } else {
          this.$message.error("请完善提交信息");
        }
      });
    },
    //用户保存贷款草稿
    async SaveBtn() {
      this.rules.income[0].required = false;
      this.rules.YearManagement[0].required = false;

      // this.$refs.ruleForm.validate(async (valid, obj) => {
      // if(valid){
      let area = this.$refs["cascader"].getCheckedNodes();
      this.form.area = area[0] ? area[0].data.fullPathName : "";
      let params = {
        financeProductId: this.financeProductId,
        departId: this.form.OrganizationItem.departId,
        areaCode: this.form.areaCode,
        area: this.form.area,
        userType: this.form.userType,
        name: this.form.ApplicationSubjectName,
        // address: this.form.identityId,
        idCardNo: this.form.SocialCreditId,
        legalPersonNo: this.form.legalPersonNo,
        phone: this.form.phone,
        userCardFrontImg: this.logoUrl2,
        userCardBackImg: this.logoUrl3,
        files: JSON.stringify(this.fileList),
        income: this.form.income,
        operatYear: this.form.YearManagement,
        money: this.form.LoansAmount,
        use: this.form.FundsUse,
        status: 0,
        legalPersonName: this.form.LegalPersonName,
        LegalPersonId: this.form.LegalPersonId,
        agentName: this.form.agentName,
        agentNo: this.form.agentNo,
        operatIntorducation: this.form.BusinessContent,
        licenseImg: this.logoUrl,
        orderId: this.form.orderId,
        warehouseNumber: this.form.mortgageAmount,
        warehouseId: this.form.warehouseReceiptId,
        warehouseCode: this.form.warehouseReceiptNumber,
      };
      let res = await ApplicationLoan(params);

      // 跳转到申请记录页面
      if (res.code == 0) {
        this.$message.success(res.msg);
        this.$router.push("/memberCenter/financalService/applicationRecord");
        // 关闭弹窗
        this.$emit("closeDialog", false);
        this.$refs.ruleForm.resetFields(); //此时不会触发表单校验
      } else {
        this.$message.info(res.msg);
      }
      // }else{
      //     this.$message.error('请完善提交信息')
      //   }
      // })
    },
    //上传
    async allUpLoad(file, type, num) {
      let param = new FormData();
      param.append("catalog", type);
      param.append("file", file.raw);
      let res = await uploadFile(param);
      let imgUrl = "/api/admin/file/get?ossFilePath=" + res.data.url;

      if (num == 1) {
        this.logoUrl = imgUrl;
      } else if (num == 2) {
        this.logoUrl2 = imgUrl;
      } else {
        this.logoUrl3 = imgUrl;
      }
    },
    //上传营业执照
    handleChange(file) {
      this.allUpLoad(file, "BusinessLicense", 1);
    },
    //上传法人身份证人面像
    handleChange2(file) {
      this.allUpLoad(file, "LegalPersonIDCardL", 2);
    },
    //上传法人身份证国徽像
    handleChange3(file) {
      this.allUpLoad(file, "LegalPersonIDCardR", 3);
    },

    //查询所在地址
    async editObj(FinancialDetails) {
      console.log(FinancialDetails, "查看传过来的详情数值");
      this.maxMoney = FinancialDetails.maxMoney;
      this.minMoney = FinancialDetails.minMoney;
      // this.financeProductId = FinancialDetails.financeProductId;
      this.loanTypeId = FinancialDetails.loanTypeId;
      this.getFundUsageOptions();

      // 判断是否为托管种植
      if (FinancialDetails.loanTypeId) {
        this.is_host_plant = FinancialDetails.loanTypeId == 179;
        this.is_host_warehouse = FinancialDetails.loanTypeId == 180;
      }
      //手动触发 弹框后 获取仓单信息
      this.handleWarehouseReceiptChange(this.form.warehouseReceiptId);

      console.log(this.topSelectAreacode, "查看顶级地址");
      let params = {
        // parentCode: FinancialDetails.areaCode,
        parentCode: this.topSelectAreacode,
      };
      let res = await AreaTree(params);
      this.options = res.data;
      this.FinancialDetails = FinancialDetails;
      this.selectDeptName();
    },
    //行政区做切换
    regionChange() {
      let node = this.$refs.cascader.getCheckedNodes()[0];
      this.areaHasChild = node.hasChildren;
      this.form.areaCode = node.value;
      this.form.areaName = node.pathLabels.join("");
      this.form.landType = "";

      setTimeout(() => {
        this.$refs.form.validateField("cascader");
      }, 100);
    },
    //查询所属机构
    async selectDeptName() {
      console.log("这里执行了嘛");
      let params = {
        financeProductId: this.FinancialDetails.financeProductId,
      };
      let res = await selectDeptName(params);

      // this.form.OrganizationItem = res.data[0];
      this.form.OrganizationItem = {}; // 先清空对象
      // 然后逐个属性赋值
      Object.keys(res.data[0]).forEach((key) => {
        this.$set(this.form.OrganizationItem, key, res.data[0][key]);
      });

      this.financeProductId = res.data[0].financeProductId;
      // let dataList=[]
      // res.data.forEach((item) => {
      //   dataList.push({
      //     departId:item.departId,
      //     departName:item.departName
      //   })
      // });
      this.institutions = res.data;
    },

    handleChangeAddress(value) {
      console.log(value);
    },

    // 点击托管单输入框
    handleCustodyOrderClick() {
      console.log("点击了托管单输入框");
      console.log(
        "showCustodyOrderDialog 当前值:",
        this.showCustodyOrderDialog
      );
      this.showCustodyOrderDialog = true;
      console.log(
        "showCustodyOrderDialog 设置后值:",
        this.showCustodyOrderDialog
      );
    },

    // 托管单选择确认
    handleCustodyOrderConfirm(selectedOrder) {
      console.log("选中的托管单:", selectedOrder);
      this.form.orderId = selectedOrder.orderId;
      this.custodyOrderDisplay = `${selectedOrder.orderNo || ""} - ${
        selectedOrder.cropCode || ""
      } - ${selectedOrder.landArea || ""}亩`;
      console.log("显示的文本:", this.custodyOrderDisplay);
    },

    // 获取托管单API函数
    getCustodyOrder(params) {
      // 可以根据当前用户信息添加筛选条件
      const { current, size, ...rest } = params;
      const requestParams = {
        ...rest,
        // 将分页参数转换为后端需要的格式
        pnum: current || 1,
        psize: size || 10,
      };
      // 删除原有的分页参数，避免冲突

      console.log("托管单API请求参数:", requestParams);
      return getApplyOrderList(requestParams)
        .then((res) => {
          console.log("托管单API响应:", res);

          // 如果后端返回的数据格式需要转换，在这里处理
          // 例如：如果返回格式是 { data: { list: [], total: 0 } }
          // 需要转换为 { data: { records: [], total: 0 } }
          if (res.data && res.data.list && !res.data.records) {
            res.data.records = res.data.list;
          }

          return res;
        })
        .catch((err) => {
          console.error("托管单API错误:", err);
          throw err;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.application {
  // width: 80%;
  // height: 80%;
  display: flex;
  flex-direction: column;
  .el-dialog {
    max-height: 90vh;
    display: flex;
    flex-direction: column;

    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
      flex: 1;
      padding: 20px;
      max-height: calc(90vh - 120px);
      overflow-y: auto;

      .LoanApplication {
        max-height: 100%;
        overflow: visible;

        .BasicInformation,
        .ManagementInformation,
        .LoanInformation {
          margin-bottom: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .textContent {
          padding: 15px;
        }
      }
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
      border-top: 1px solid #ebeef5;
    }
  }

  @media (max-width: 1200px) {
    .el-dialog {
      width: 90% !important;
      margin-top: 2vh !important;
    }
  }

  @media (max-width: 768px) {
    .el-dialog {
      width: 95% !important;
      margin-top: 1vh !important;

      .el-dialog__body {
        padding: 15px;
      }
    }
  }

  .LoanApplication {
    // width: 100%;
    // height: 100%;

    /*服务网点*/
    .serviceOutlets {
      .el-form {
        margin-left: 25px;
      }

      /deep/.el-form-item {
        margin-top: 20px;

        .el-form-item__label {
          width: 96px;
          height: 40px;
          font-size: 15px;
          font-weight: bold;
          text-align: center;
        }

        .el-form-item__content {
          width: 322px;
        }
      }

      /*是否平移*/
      /* /deep/.el-form-item__content{
        margin-left: 119px;
      }*/
    }

    /*基础信息*/
    .BasicInformation {
      display: flex;
      border: solid 1px #cccc;

      .title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
        }
      }

      .textContent {
        width: 88%;
        display: flex;
        padding: 10px;

        .Left {
          width: 50%;
          height: 100%;

          /deep/.el-form-item {
            width: 100%;

            .el-input {
              width: 200px;
            }

            .el-form-item__label {
              width: 96px;
              height: 40px;
            }
          }
        }

        .Right {
          width: 50%;
          height: 100%;

          /deep/.el-form-item {
            width: 100%;

            .el-input {
              width: 200px;
            }

            .el-form-item__label {
              width: 124px;
              height: 40px;
            }
          }
        }
      }
    }

    /*经营信息*/
    .ManagementInformation {
      display: flex;
      border: solid 1px #cccc;

      .title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
        }
      }

      .textContent {
        width: 80%;
        display: flex;
        flex-direction: column;
        padding: 10px;

        .textContent_top {
          width: 100%;
          display: flex;

          .Left {
            width: 45%;
            display: flex;

            p {
              display: flex;
              justify-content: space-between;
              padding: 0px 5px;

              span {
                i {
                  color: red;
                }
              }
            }

            /deep/.el-form-item {
              display: flex;

              .el-input {
                width: 150px;
              }

              .el-form-item__label {
                width: 96px;
                height: 40px;
              }
            }
          }

          .Right {
            width: 45%;
            display: flex;

            /deep/.el-form-item {
              .el-form-item__label {
                width: 120px !important;
              }
            }

            p {
              display: flex;
              justify-content: space-between;

              span {
                i {
                  color: red;
                }
              }
            }

            /deep/.el-form-item {
              display: flex;

              .el-input {
                width: 150px;
              }

              .el-form-item__label {
                width: 96px;
                height: 40px;
              }
            }
          }
        }

        .textContent_bottom {
          width: 100%;
          display: flex;

          span {
            width: 100px;
            margin: 0px 2px;
            line-height: 50px;
          }
        }
      }
    }

    /*贷款信息*/
    .LoanInformation {
      display: flex;
      border: solid 1px #cccc;

      .title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
        }
      }

      .textContent {
        width: 80%;
        display: flex;
        flex-direction: column;
        padding: 10px;

        .LoanInformation_top {
          .Left {
            display: flex;

            /deep/.el-form-item {
              display: flex;

              .el-input {
                width: 200px;
              }

              .el-form-item__error {
                color: #f56c6c;
                font-size: 12px;
                line-height: 1;
                padding-top: 4px;
                position: absolute;
                top: 100%;
                left: 0;
              }

              .el-form-item__label {
                width: 96px;
                height: 40px;
              }

              .el-form-item__content {
                .active {
                  input {
                    border: solid 1px #f56c6c;
                  }
                }
              }
            }

            p {
              margin-left: 10px;
            }

            .Exceed {
              color: red;
            }
          }
        }

        .LoanInformation_bottom {
          width: 100%;
          display: flex;

          span {
            width: 100px;
            line-height: 50px;
          }
        }
      }
    }

    /*营业执照*/
    .BusinessLicense {
      display: flex;
      border: solid 1px #ccc;
      padding: 10px;

      .title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
        }
      }

      .textContent {
        width: 48%;
        display: flex;
        justify-content: space-around;
        padding-left: 10px;

        /deep/.el-image {
          img {
            width: 200px;
            height: 100px;
            padding: 5px 0px;
          }

          .image-slot {
            img {
              width: 100px;
              height: 80px;
            }
          }
        }

        img {
          width: 200px;
          height: 100px;
        }

        p {
          width: 94px;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
      }
    }

    /*法人身份证*/
    .LegalPersonIDCard {
      display: flex;
      border: solid 1px #ccc;
      padding: 10px;

      .title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 15px;
          font-weight: bold;
          text-align: center;

          i {
            color: red;
          }
        }
      }

      .Left {
        width: 50%;
        display: flex;
        padding-left: 50px;
        justify-content: space-around;

        /deep/.el-image {
          img {
            width: 200px;
            height: 100px;
            padding: 5px 0px;
          }

          .image-slot {
            img {
              width: 100px;
              height: 80px;
            }
          }
        }

        p {
          width: 94px;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }

        .title {
          font-size: 15px;
          font-weight: bold;
        }
      }

      .Right {
        width: 50%;
        display: flex;
        justify-content: space-around;

        /deep/.el-image {
          img {
            width: 200px;
            height: 100px;
            padding: 5px 0px;
          }

          .image-slot {
            img {
              width: 100px;
              height: 80px;
            }
          }
        }

        p {
          width: 94px;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }

        .title {
          font-size: 15px;
          font-weight: bold;
        }
      }
    }

    /*其他附件*/
    .OtherAccessories {
      border: solid 1px #ccc;
      display: flex;

      .title {
        width: 10%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        p {
          font-size: 15px;
          font-weight: bold;
          text-align: center;

          i {
            color: red;
          }
        }
      }

      .textContent {
        width: 100%;
        height: 120px;
        display: flex;
        border: solid 1px #ccc;

        .Item {
          width: 150px;
          height: 100%;
          display: flex;
          flex-direction: column;
          text-align: center;
          position: relative;
          padding: 10px;

          .el-image {
            width: 150px;
            height: 85px;
            background: #e6e3e3;

            img {
              width: 200px;
              height: 50px;
            }

            i {
              font-size: 50px;
              font-weight: bold;
              margin-top: 20px;
            }
          }

          span {
            margin-top: 5px;
          }

          .del {
            width: 20px;
            height: 20px;
            border: solid 1px black;
            border-radius: 50px;
            display: none;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 5000;
            text-align: center;
            line-height: 20px;
          }
        }

        .Item:hover {
          .del {
            display: block;
          }
        }

        .upload-demo {
          i {
            font-size: 50px;
            font-weight: bold;
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>
